import React, { Component } from 'react';
import Tabs from './Tabs';
import TabPanels from './TabPanels';
import TabPanel from './TabPanel';
import './TabsWrapper.scss';

class TabsWrapper extends Component {
  state = {
    activeTab: this.props.activeTab,
  };

  componentDidUpdate(prevProps, prevState) {
    const { activeTab } = this.state;
    const { toggleActiveTab } = this.props;
    if (prevState.activeTab !== activeTab) {
      const currentTab = activeTab === 0 ? 'Images' : 'Videos';
      typeof toggleActiveTab === 'function' && toggleActiveTab(currentTab);
    }
  }

  toggleTab = (newIndex, enabled) => {
    const { populateSnackBar, updateActiveTab } = this.props;
    if (!enabled) {
      updateActiveTab ? updateActiveTab(0) : this.setState({ activeTab: 0 });
      populateSnackBar({
        showSnackBar: true,
        message: 'To access this feature, contact support@concept3d.com.',
        clearDelay: 5000,
      });
    } else {
      updateActiveTab
        ? updateActiveTab(newIndex)
        : this.setState({ activeTab: newIndex });
    }
  };

  render() {
    const {
      type,
      data,
      width,
      primaryColor,
      activeTab: propsActiveTab,
      updateActiveTab,
      mediaLibrary,
    } = this.props;
    const activeTab = updateActiveTab ? propsActiveTab : this.state.activeTab;

    return (
      <section id="tabs-wrapper" data-cy={`active-tab-${activeTab}`}>
        {/* active-tab-${activeTab} for cypress - active tab is the index */}
        <Tabs
          type={type}
          width={width}
          borderColor={primaryColor}
          tabList={data}
          toggleTab={this.toggleTab}
          activeTab={activeTab}
          mediaLibrary={mediaLibrary}
        />
        <TabPanels index={activeTab}>
          {data.map(tab => (
            <TabPanel key={tab.title}>{tab.Component}</TabPanel>
          ))}
        </TabPanels>
      </section>
    );
  }
}

export default TabsWrapper;
